import {isMobileDevice} from '@/_application/core/hooks/useIsMobileDevice';
import {ArrowNextIcon} from '@/_application/icons/arrow-next';
import Link from '@/_application/core/components/ui/link';

interface ICustomLinkWithArrowProps {
    href: string;
    text: string;
}

const CustomLinkWithArrow = ({href, text}: ICustomLinkWithArrowProps) => {
    if (isMobileDevice())
        return (
            <Link
                href={href}
                className="group flex items-center justify-center gap-1.5 text-xs text-primary md:text-sm">
                {text}
                <ArrowNextIcon className="h-2.5 w-2.5 text-primary transition-transform group-hover:-translate-y-px group-hover:-rotate-45" />
            </Link>
        );

    return (
        <Link
            href={href}
            className="group flex h-[38px] w-[140px] items-center justify-center gap-1.5 rounded-full bg-primary text-base font-bold text-white transition-colors hover:bg-KPZ_turquoise">
            {text}
            <ArrowNextIcon className="h-3 w-3 text-white transition-transform group-hover:-translate-y-px group-hover:-rotate-45" />
        </Link>
    );
};

export default CustomLinkWithArrow;
